import styles from "./TextHighLighter.module.scss";

const HighLighter = ({ str, findValue, customClass }) => {
  const splitValues = str.split(" ");
  return (
    <div className={customClass} id={str}>
      {splitValues.map((item, index) => (
        <span
          key={index}
          className={` ${styles["normalText"]} ${
            styles[item.match(findValue) && "textHighlight"]
          }`}
        >
          {item}{" "}
        </span>
      ))}
    </div>
  );
};

export default HighLighter;
